'use client'

import { useRef } from 'react'
import { useTrackElementImpression, useTrackElementInteracted } from '@nwwp/segment-analytics'

type TrackedLinkProps = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & {
  href: string
  segmentElement?: string
  segmentEventName?: string
}

export const TrackedLink = ({
  href,
  target,
  rel,
  children,
  segmentElement,
  segmentEventName,
  onClick,
  ...props
}: TrackedLinkProps) => {
  const trackElementInteracted = useTrackElementInteracted()
  const linkRef = useRef<HTMLAnchorElement>(null)
  const element = segmentElement ?? 'TrackedLink'

  useTrackElementImpression(linkRef, { element })

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    void trackElementInteracted({
      element,
      ...(segmentEventName ? { eventName: segmentEventName } : {}),
      href,
    })

    onClick?.(event)
  }

  return (
    <a
      ref={linkRef}
      href={href}
      target={target}
      rel={target === '_blank' ? `noopener noreferrer${rel ? ` ${rel}` : ''}` : rel}
      onClick={handleClick}
      {...props}
    >
      {children}
    </a>
  )
}
